import { render } from "./UpdateLocation.vue?vue&type=template&id=f6e8ed5e"
import script from "./UpdateLocation.vue?vue&type=script&lang=js"
export * from "./UpdateLocation.vue?vue&type=script&lang=js"

import exportComponent from "D:\\courses\\Web Design\\JAVA  SCRIPT\\Vue-js courses\\resturant\\mat-aem\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__